module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAYAAABGkiVgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQ5JREFUeNqk0jtLw1AYxvH0MtWhUwepIkLWzv0GYh06dBPBwSHg0L32A5TuHboJiqWZI7QUwVWcHIJfQAsZOnWNQ/0feAJSYnPpCz8O5/bASd6C4zhWiqrhEddYJR0upgis4BnnGiv7hpYwRRMvGqdazxVawD3aGOJMo5k/aD+2yjtCB/qGE/S1ZsZjXOEbd1lCb9HDK26w0fpG80Ptf2Gc5vnmeSP46CDc2g+17utcOyk0+hEBLrD+5yVr7Qd/fmRsqK2WCXVhmdAZS5370T17O7SOOQ7Uj76Vrsy5lu4tcBSFVhV4iku8W9nqTfdOMDN5JtRFA114Vr7ydN/kuKalnvAR1xoZa6we/vwVYABgjTb7Lir30gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/header/img/up.png
// module id = FIj8
// module chunks = 1